import { GridColProps, GridRowProps, GridProps } from '@procore/core-react/dist/_typedoc/Grid/Grid.types.json';
import * as React from 'react';
export default {
  GridColProps,
  GridRowProps,
  GridProps,
  React
};